import Modal from "../../../../components/Modal";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import Dropdown from "../../../../components/Dropdown";
import Pagination from "../../../../components/Pagination";
import Table from "../../../../components/Table";
import FormCard from "../../../../components/FormCard";
import DeleteButton from "../../../../components/deleteButton";
import SmallerSpinner from "../../../../components/SmallerSpinner";
import DatePicker from "../../../../components/DatePicker";
import styles from "../css/ecoControlFridges.module.css";

export default function FridgeContentsModal({
  showContents,
  selectedFridge,
  contentsRows,
  contentsPage,
  contentsEdit,
  cItemName,
  cSku,
  cBatch,
  cQty,
  cUnity,
  cExpiry,
  contentsCategory,
  roleId,
  onClose,
  onContentsPageChange,
  onEdit,
  onSave,
  onItemNameChange,
  onSkuChange,
  onBatchChange,
  onQtyChange,
  onUnityChange,
  onExpiryChange,
  onCategoryChange,
  onRemoveItem
}) {
  if (!showContents) return null;

  return (
    <Modal onClose={() => { onClose(); }}>
      <div className={styles.contentsWrap}>
        <h2 className={styles.detailsTitle}>{(selectedFridge?.name || 'Fridge 1')} Contents</h2>

        {/* Summary small inputs */}
        <div className={styles.smallInputsRow}>
          <FormInput label="Total Quantity" value={150} onChange={() => {}} />
          <FormInput label="Temperature °C" value={5} onChange={() => {}} />
          <FormInput label="Bin Number" value={(selectedFridge?.bin || '001').replace('Bin ', '')} onChange={() => {}} />
          <FormInput label="Fridge Serial Number" value={'02589630147800'} onChange={() => {}} />
        </div>

        {/* Filter By */}
        {roleId === 3 ? (
          <div style={{ display: 'flex', justifyContent: 'center', margin: '0.3rem 0 0.5rem' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.35rem',
                background: '#fff',
                border: '1px solid #e6d8ff',
                borderRadius: 8,
                padding: '0.15rem 0.35rem',
                boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
              }}
            >
              <span className={styles.filterLabel} style={{ marginRight: '0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>Filter By</span>
              <div style={{ width: 140 }}>
                <Dropdown
                  name="category"
                  placeholder="Category"
                  options={["Vaccine","Insulin","Antibiotics"]}
                  value={contentsCategory}
                  onChange={onCategoryChange}
                  className={styles.pillSelect}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.filterRow}>
            <span className={styles.filterLabel}>Filter By</span>
            <Dropdown name="category" placeholder="Category" options={["Vaccine","Insulin","Antibiotics"]} value={contentsCategory} onChange={onCategoryChange} />
          </div>
        )}

        {/* Contents Table */}
        <div className={styles.contentsTableWrap}>
          <div className={styles.contentsTableCard}>
            <Table
            columns={[
              { header: 'Item ID', accessor: 'id' },
              { header: 'Item Name', accessor: 'name' },
              { header: 'Batch', accessor: 'batch' },
              { header: 'SKU', accessor: 'sku' },
              { header: 'Category', accessor: 'category' },
              { header: 'Qty', accessor: 'qty' },
              { header: 'Expiry Date', accessor: 'exp' },
              { header: 'Unity', accessor: 'unity' },
              ...(contentsEdit ? [{
                header: 'Remove Item', accessor: 'remove', render: (_val, row) => (
                  <div className={styles.centerCell}>
                    <DeleteButton onClick={() => onRemoveItem(row.id)} />
                  </div>
                )
              }] : []),
            ]}
            data={contentsRows}
            />
          </div>
        </div>

        {contentsEdit && (
          <div className={styles.contentsEditSection}>
            <FormCard className={styles.smallCard}>
              <div className={styles.cardHeaderRow}>
                <h3 className={styles.cardTitle}>Add Item to Fridge</h3>
              </div>
              <div className={styles.formGrid}>
                <FormInput label="Item Name" placeholder="e.g., Amoxicillin 500mg" value={cItemName} onChange={onItemNameChange} />
                <FormInput label="SKU" placeholder="e.g., MED-12345" value={cSku} onChange={onSkuChange} />
                <FormInput label="Batch Number" placeholder="e.g., BT-2024-001" value={cBatch} onChange={onBatchChange} />
                <div style={roleId === 3 ? { display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' } : undefined}>
                  <div className={styles.fieldLabel}>Quantity</div>
                  <div className={styles.qtyCompact} style={roleId === 3 ? { transform: 'none', marginTop: 10 } : undefined}>
                    <SmallerSpinner
                      value={cQty}
                      onChange={onQtyChange}
                      ariaLabel="Quantity"
                      compact={roleId === 3 ? false : undefined}
                      className={roleId === 3 ? styles.pageSpinnerFix : undefined}
                      style={roleId === 3 ? { height: 40, minWidth: 140, width: 140 } : undefined}
                    />
                  </div>
                </div>
                <Dropdown name="unity" label="Unity" placeholder="Select unity" options={['Vials','Injections','Syringes','Box','Pack','Bottle']} value={cUnity} onChange={onUnityChange} />
                <div>
                  <div className={styles.fieldLabel}>Expiry Date</div>
                  <DatePicker selectedDate={cExpiry} onDateChange={onExpiryChange} />
                </div>
              </div>
              <div className={styles.footerActions}>
                <Button variant="primary">Add to Fridge</Button>
              </div>
            </FormCard>
          </div>
        )}

        {/* Pagination + actions */}
        <div className={styles.contentsFooter}>
          <Pagination currentPage={contentsPage} totalPages={3} onPageChange={onContentsPageChange} />
          <div className={styles.detailsButtons}>
            {!contentsEdit ? (
              <Button variant="primary" onClick={onEdit}>Edit</Button>
            ) : (
              <Button variant="primary" onClick={onSave}>Save</Button>
            )}
            <Button variant="secondary" onClick={() => { onClose(); }}>Close</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

